import styled from "styled-components";
import { animated } from "react-spring";

// Floating "map" window that hovers over the maximized planta. Lives inside
// ImageContainerPlantas, so it only shows (opacity/pointer-events) when that
// container gets the .in class (planta maximized). Sits below the close/duplex
// buttons (z-index 10000) so those stay clickable.
//
// Layout = a solid header bar on top + the image below it at its natural ratio
// (PipImg is width:100% height:auto). So the window height is exactly
// header + image, with no letterbox/background around the image.
export const PipContainer = styled(animated.div)`
  position: absolute;
  top: 80px;
  left: 1300px;
  z-index: 9000;
  width: 520px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.18);
  touch-action: none;
  user-select: none;
  will-change: transform;

  /* Collapsed: hide the image, leaving just the header bar. */
  &.collapsed .pip-img {
    display: none;
  }
`;

// Solid bar above the image — the drag handle (no title).
export const PipHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  padding: 7px 10px;
  background: #f1f1f1;
  cursor: grab;

  &:active {
    cursor: grabbing;
  }
`;

// Small grip affordance (three lines) so the bar reads as a drag handle.
export const PipGrip = styled.div`
  width: 16px;
  height: 8px;
  pointer-events: none;
  background: repeating-linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.45) 0 1.5px,
    transparent 1.5px 4px
  );
`;

export const PipActions = styled.div`
  display: flex;
  gap: 6px;
`;

export const PipButton = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #ffffff;
  border: 1px solid #cccccc;
  font-size: 16px;
  line-height: 1;
  color: #000000;

  &:active {
    background: #e6e6e6;
  }
`;

// Image fills the window width; its height (auto, natural ratio) drives the
// window height. Zoom changes the container width, so this scales with it.
export const PipImg = styled.img`
  display: block;
  width: 100%;
  height: auto;
  pointer-events: none;
  user-select: none;
  -webkit-user-drag: none;
`;
